import React from 'react';
import { useAppVersion } from '../hooks/useAppVersion';

const UpdateAvailableToast: React.FC = () => {
  const { updateAvailable, dismissUpdate } = useAppVersion();

  if (!updateAvailable) {
    return null;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        background: 'rgba(15, 23, 42, 0.95)',
        color: '#fff',
        padding: '16px 18px',
        borderRadius: '8px',
        minWidth: '320px',
        maxWidth: '420px',
        zIndex: 2000,
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.35)',
        border: '1px solid #334155',
      }}
    >
      <div style={{ marginBottom: '12px', lineHeight: 1.45 }}>
        A new version of Q-DESIGN is available. Refresh to get the latest features and fixes.
      </div>
      <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
        <button
          type="button"
          onClick={dismissUpdate}
          style={{
            background: 'transparent',
            color: '#94a3b8',
            border: '1px solid #475569',
            borderRadius: '4px',
            padding: '8px 12px',
            cursor: 'pointer',
          }}
        >
          Dismiss
        </button>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            background: '#4f46e5',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            padding: '8px 12px',
            cursor: 'pointer',
            fontWeight: 500,
          }}
        >
          Refresh
        </button>
      </div>
    </div>
  );
};

export default UpdateAvailableToast;
